import React from "react";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../store/hooks";

interface IProps {
    vendor: {
        stats: {
            properties_count_for_sale: number;
        };
    };
    className?: string;
}

const offerPluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);

export const VendorDetailSubHeader: React.FC<IProps> = ({vendor, className}) => {
    const propertiesCount = vendor.stats.properties_count_for_sale;
    const activeOffersCount = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.count);

    return Number.isFinite(activeOffersCount) ? (
        <Text as="h2" variant="headline_3" className={className}>
            Posiadamy w sprzedaży{" "}
            <Highlight>
                {numberFormat(propertiesCount)} {propertyPluralize(propertiesCount)} w {numberFormat(activeOffersCount)} {offerPluralize(activeOffersCount)}
            </Highlight>
        </Text>
    ) : null;
};
import React from "react";

import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {useAppSelector} from "../../../store/hooks";

interface IProps {
    vendor: {
        stats: {
            properties_count_for_sale: number;
        };
    };
    className?: string;
}

const offerPluralize = pluralize(["inwestycji", "inwestycjach", "inwestycjach"]);
const propertyPluralize = pluralize(["nieruchomość", "nieruchomości", "nieruchomości"]);

export const VendorDetailSubHeader: React.FC<IProps> = ({vendor, className}) => {
    const propertiesCount = vendor.stats.properties_count_for_sale;
    const activeOffersCount = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.count);

    return Number.isFinite(activeOffersCount) ? (
        <Text as="h2" variant="headline_3" className={className}>
            Posiadamy w sprzedaży{" "}
            <Highlight>
                {numberFormat(propertiesCount)} {propertyPluralize(propertiesCount)} w {numberFormat(activeOffersCount)} {offerPluralize(activeOffersCount)}
            </Highlight>
        </Text>
    ) : null;
};
